import React from 'react'

import InlineSVG from 'svg-inline-react'

import CompanyIconSrc from '~/client/static/icons/company.svg'
import StatusScheduledIconSrc from '~/client/static/icons/delivery-planned.svg'
import StatusDoneIconSrc from '~/client/static/icons/done.svg'
import StatusFailedIconSrc from '~/client/static/icons/fail.svg'
import FootballHelmetIconSrc from '~/client/static/icons/football_helmet.svg'
import StatusOnSiteIconSrc from '~/client/static/icons/on-site.svg'
import StatusPassedIconSrc from '~/client/static/icons/pass.svg'
import StatusRequestedIconSrc from '~/client/static/icons/requested.svg'
import DefaultTeamSrc from '~/client/static/icons/tag-icons/default-team.svg'
import TradeSrc from '~/client/static/icons/trade.svg'
import UserIconSrc from '~/client/static/icons/user.svg'
import WrenchIconSrc from '~/client/static/icons/wrench.svg'

interface IProps {
  color?: string
  size?: number

  [key: string]: any
}

const DEFAULT_SIZE = 12
const DEFAULT_COLOR = 'currentColor'

export function StatusScheduled(props: IProps) {
  return renderInlineSvg(StatusScheduledIconSrc, props)
}

export function StatusOnSite(props: IProps) {
  return renderInlineSvg(StatusOnSiteIconSrc, props)
}

export function StatusRequested(props: IProps) {
  return renderInlineSvg(StatusRequestedIconSrc, props)
}

export function StatusPassed(props: IProps) {
  return renderInlineSvg(StatusPassedIconSrc, props)
}

export function StatusFailed(props: IProps) {
  return renderInlineSvg(StatusFailedIconSrc, props)
}

export function StatusDone(props: IProps) {
  return renderInlineSvg(StatusDoneIconSrc, props)
}

export function Company(props: IProps) {
  return renderInlineSvg(CompanyIconSrc, props)
}

export function Team(props: IProps) {
  return renderInlineSvg(FootballHelmetIconSrc, props)
}

export function Trade(props: IProps) {
  return renderInlineSvg(TradeSrc, props)
}

export function Role(props: IProps) {
  return renderInlineSvg(WrenchIconSrc, props)
}

export function User(props: IProps) {
  return renderInlineSvg(UserIconSrc, props)
}

export function DefaultTeam(props: IProps) {
  return renderInlineSvg(DefaultTeamSrc, props)
}

function renderInlineSvg(src: any, props: IProps): JSX.Element {
  const { color = DEFAULT_COLOR, size = DEFAULT_SIZE, stroke, ...rest } = props

  return (
    <InlineSVG
      {...rest}
      src={src}
      style={{
        color,
        stroke,
        fill: color,
        width: size,
        height: size,
        display: 'flex',
        flexBasis: size,
      }}
    />
  )
}
